import React from 'react';
import {useAppleID} from './hooks';
import {LoginWithPhone} from './components';

export function Login() {
  useAppleID({
    clientId: 'fm.alto',
    scope: 'name email',
    redirectURI: 'ADD-REDIRECT-URI-HERE',
    state: 'Initial Auth Request',
    usePopup: true,
  });

  const loginWithPhoneMarkup = <LoginWithPhone />;

  const signInWithAppleMarkup = (
    <div
      id="appleid-signin"
      data-color="black"
      data-border="true"
      data-type="sign in"
    ></div>
  );

  return (
    <>
      {loginWithPhoneMarkup}
      {signInWithAppleMarkup}
    </>
  );
}
